import { createContext, useContext, useMemo, useState, type ReactNode } from "react"

export type AgentPageDocumentContext = {
  suggestedSpaceId: number
  suggestedSpaceName: string
  suggestedSpaceType: "GENERAL" | "ENTITY"
  folderId?: number
  nodeId?: number
}

type Value = { documentContext: AgentPageDocumentContext | null; setDocumentContext: (value: AgentPageDocumentContext | null) => void }
const AgentPageContext = createContext<Value>({ documentContext: null, setDocumentContext: () => undefined })

export function AgentPageContextProvider({ children }: { children: ReactNode }) {
  const [documentContext, setDocumentContext] = useState<AgentPageDocumentContext | null>(null)
  const value = useMemo(() => ({ documentContext, setDocumentContext }), [documentContext])
  return <AgentPageContext.Provider value={value}>{children}</AgentPageContext.Provider>
}

export const useAgentPageContext = () => useContext(AgentPageContext)
